import { useEffect, useMemo, useState } from "react";
import { Option } from "../../common/commonSelect";
import webservice_url, { master_baseUrl } from "../../webservice/Webservice_url";
import useApi from "../useApi";


interface dataTypes {
    agency_user_id: string;
    full_name: string;
}

// all managers 
export function useManagerhook() {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>(webservice_url.get_managers_list, {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.full_name ?? "",
            value: d?.agency_user_id ?? "",
        }))
    }, [dataList])

    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi();
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err)
        }
    }

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // selectedItem
    // const selectedItem = useMemo<any>(() => {
    //     if (!selectedPackageId) return null;
    //     return dataList.find((d) => d.package_id === selectedPackageId) ?? null;
    // }, [dataList, selectedPackageId]);


    return { dataList, options, loading };
}


// all managers by orgId, projectId, programId
export function useManagerByFilters(orgId: string, projectId?: string, programId?: string) {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>("", {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.full_name ?? "",
            value: d?.agency_user_id ?? "",
        }))
    }, [dataList])

    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi(undefined, `${webservice_url.get_managers_by_filters}org_id=${orgId}&project_id=${projectId}&program_id=${programId}`);
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err)
        }
    }

    useEffect(() => {
        if (!orgId || !projectId || !programId) return;
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // selectedItem
    // const selectedItem = useMemo<any>(() => {
    //     if (!selectedPackageId) return null;
    //     return dataList.find((d) => d.package_id === selectedPackageId) ?? null;
    // }, [dataList, selectedPackageId]);


    return { dataList, options, loading };
}